import { render, staticRenderFns } from "./OrderStatusLegend.vue?vue&type=template&id=25ef242d"
import script from "./OrderStatusLegend.vue?vue&type=script&lang=js"
export * from "./OrderStatusLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports